<template>
  <div class="productListing">

    <section class="detail_content">
      <header class="main_customHeading" style="justify-content: space-between;">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h2>{{$t('productList')}}</h2>
        <div class="icon_wrapper" style="justify-content: flex-end;">
        <router-link :to="{ path: '/cart-check-out?source=LOCAL91_CATEGORY_BROWSING'}" tag="span" class="tabIcon">
          <span class="one-cart-size" v-if="cartSize > 0" style="top: 5px;right: 4px;">{{cartSize}}</span>
          <span class="add-no">{{cartSize}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 26">
          <g >
            <path
            fill= "#505050"
              d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443c-.092 1.172.322 2.338 1.135 3.2C1.963 25.505 3.116 26 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357.813-.862 1.227-2.028 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582c-.528.56-1.247.87-2.025.87H4.313c-.778 0-1.497-.31-2.025-.87-.529-.56-.787-1.288-.728-2.047L2.743 6.926c.012-.154.145-.274.302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
            />
          </g>
        </svg>

        </router-link>
        </div>

      </header>
      <div class="addToHome" v-if="hideAddtoHomeShowJSbridge">
        <div
          :class="hideAddtoHomeShowJSbridge ? 'addtohomescreen active_homescreen' : 'addtohomescreen'"
        >
          <div class="logo-imgbox">
            <img :src="addTohomeImage" alt="add-to-home" />
          </div>
          <div class="textbox" @click="JsBridgeOpenPrompt()">
            <span id="ad2hs-prompt">Add {{DukaanbusinessName.toLowerCase()}} to Home Screen</span>
          </div>
          <div class="close-prompt">
            <i class="material-icons" @click="JsBridgehideAddtoHome()">close</i>
          </div>
        </div>
      </div>
      <div class="bottom_filter" v-if="filterProducts.categoryFilterDTOs">
        <div
          class="item"
          @click="sortProduct = !sortProduct"
          style="border-right: 1px solid rgba(0, 0, 0, 0.28);"
          v-if="salesProducts.length"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <g fill="#0091FF">
              <path
                d="M11.535 15.349H8.977a.31.31 0 00-.23.09.312.312 0 00-.09.23v1.918c0 .094.03.17.09.23s.137.09.23.09h2.558a.31.31 0 00.23-.09.31.31 0 00.09-.23V15.67a.31.31 0 00-.09-.23.31.31 0 00-.23-.09zM6.739 14.07H4.82V.32c0-.093-.03-.17-.09-.23A.312.312 0 004.5 0H2.583c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v13.75H.344c-.147 0-.247.066-.3.2-.054.126-.03.243.07.35l3.197 3.197c.074.06.15.09.23.09.087 0 .163-.03.23-.09l3.188-3.188c.066-.08.1-.16.1-.24 0-.093-.03-.17-.09-.23a.312.312 0 00-.23-.09zM13.454 10.233H8.977c-.093 0-.17.03-.23.09a.311.311 0 00-.09.23v1.918c0 .093.03.17.09.23s.137.09.23.09h4.477a.31.31 0 00.23-.09.31.31 0 00.09-.23v-1.919a.31.31 0 00-.09-.23.31.31 0 00-.23-.09zM17.521.09a.312.312 0 00-.23-.09H8.977c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v1.918c0 .094.03.17.09.23s.137.09.23.09h8.314c.094 0 .17-.03.23-.09s.09-.136.09-.23V.32c0-.093-.03-.17-.09-.23zM15.373 5.116H8.977c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v1.919c0 .093.03.17.09.23s.137.09.23.09h6.396c.093 0 .17-.03.23-.09s.09-.137.09-.23V5.436c0-.093-.03-.17-.09-.23a.313.313 0 00-.23-.09z"
              />
            </g>
          </svg>
          <span>
            {{$t('sort')}}
            <strong v-if="sortOption">.</strong>
          </span>
        </div>
        <div class="item" @click="viewAllCat()">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18">
            <g fill="#0091FF">
              <path
                d="M3.328 2.981h-.173V1.024a.993.993 0 10-1.987 0V2.98H.994a.994.994 0 100 1.988h.174v11.284a.993.993 0 101.987 0V4.97h.173a.994.994 0 100-1.988zM7.967 11.595h-.174V1.024a.993.993 0 10-1.987 0v10.57h-.174a.994.994 0 000 1.989h.174v2.67a.994.994 0 101.987 0v-2.67h.174a.994.994 0 000-1.988zM12.605 6.294h-.174v-5.27a.994.994 0 00-1.987 0v5.27h-.174a.994.994 0 000 1.988h.174v7.971a.993.993 0 101.987 0V8.282h.174a.994.994 0 000-1.988zM17.243 1.656h-.173v-.632a.994.994 0 00-1.988 0v.632h-.173a.994.994 0 100 1.988h.173v12.61a.993.993 0 101.988 0V3.643h.173a.994.994 0 100-1.988z"
              />
            </g>
          </svg>
          <span>
            {{$t('filter')}}
            <strong v-if="appliedFilter">.</strong>
          </span>
        </div>
      </div>
      <div class="bottomToUp" v-if="sortProduct"></div>
      <div class="bottomToUp_content" :class="{'activeBottomtoUp' : sortProduct}">
        <div class="popup_content sort">
          <h5 class="prdt_hdng">{{$t('sortBy')}}</h5>
          <ul class="sort-item">
            <li
              @click="sortByPrice('NEW_ITEM')"
              :class="{'sortOption' : sortOption === 'NEW_ITEM'}"
            >{{$t('whatsNew')}}</li>
            <li
              @click="sortByPrice('ASC')"
              :class="{'sortOption' : sortOption === 'ASC'}"
            >{{$t('priceLowToHigh')}}</li>
            <li
              @click="sortByPrice('DESC')"
              :class="{'sortOption' : sortOption === 'DESC'}"
            >{{$t('priceHighToLow')}}</li>
          </ul>
        </div>
        <span class="closePopUp" @click="sortProduct = !sortProduct">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
      <CategoryFilterOption
        :dataValue="filterProducts"
        @closeAllCat="closeAllCat"
        @getFilterList="getAppliedFilterList"
        :isFilterOption="isFilterOption"
        :class="{'hideClass' : !isDisplay}"
        @getFilterClear="getClearFilter"
      />
      <div
        :class="{'hideClass' : isDisplay, 'merchandiseProduct' : merchandiseId}"
        class="product_listing_detail"
      >
        <CategoryFilter
          :dataValue="filterProducts"
          @selectedCategory="getProductByCategory"
          @viewAllCat="viewAllCat()"
          :selectedcategoryName="selectedcategoryName"
          :choosedCatId="choosedCatId"
        />

        <div class="filter_product_list" v-if="salesProducts.length > 0" style="padding:20px 15px 0px">
        <h3 class="section_heading" style="width:100%" v-if="$route.query.type=='GMALL_FACTORY_PRODUCTS'">{{this.$t('qualityProductTitle')}}</h3>
          <div
            ref="container"
            class="filter_card"
            v-for="(product,index) in salesProducts"
            :key="index"
           
          >
            <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.itemDTOList[0].itemMediaDTOList[0]">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.itemDTOList[0].itemMediaDTOList[0].small" alt />
            </div>
            <div class="img_wrapper" v-else>
              <img src="../assets/images/watermark1.jpg" alt />
            </div>
            <div class="product_detail">
              <p class="product-name">{{product.productName}}</p>
              <div class="my_price_section">
                <span class="my_price">Mall91 Price <span class="rupee-font">₹​</span>{{product.itemDTOList[0].purchasePrice}}</span>
                <span class="selling_price">MRP <span class="rupee-font">₹​</span>​{{product.itemDTOList[0].mrp}}</span>
                
              </div>
              <div class="option_selection">
                <div class="add-option" @click="addToShop(index,product, parseFloat(product.itemDTOList[0].sellingPrice), parseFloat(product.itemDTOList[0].mrp), parseFloat(product.itemDTOList[0].purchasePrice))" v-if="!product.isAlreadyExist && $route.query.CLOUDSHOP">ADD TO SHOP</div>
                <div class="add-option" @click="openAddMarginProduct(index)" v-if="!product.isAlreadyExist && !$route.query.CLOUDSHOP">Add your margin</div>
                <div class="add-option added" v-if="product.isAlreadyExist">Added</div>
              </div>
              <div class="bottomToUp" v-if="addMarginOnProduct === index"></div>
                <div class="bottomToUp_content" :class="{'activeBottomtoUp' : addMarginOnProduct === index}">
                    <div class="popup_content sort supplyItem">
                    <h5 class="prdt_hdng">{{product.productName}}</h5>
                    <div class="price-detail flx">
                        <p class="my_price"> <span class="rupee-font">₹​</span>{{parseFloat(product.itemDTOList[0].mrp)}}.00 <br />
                            <span class="text">MRP</span>
                        </p>
                        <p class="selling_price"> <span class="rupee-font">₹​</span>​{{parseFloat(product.itemDTOList[0].purchasePrice)}}.00 <br />
                            <span class="text">Mall91 Price</span>
                        </p>
                    </div>
                    <div class="enter-margin-price">
                        <label for="">Your Price</label>
                        <input type="number" placeholder="Enter Price" :min="product.itemDTOList[0].sellingPrice" :max="product.itemDTOList[0].mrp" v-model="updatedSellingPrice" />
                    </div>
                    <button type="button" class="add-supply-product" @click="addProduct(index,product, parseFloat(product.itemDTOList[0].sellingPrice), parseFloat(product.itemDTOList[0].mrp), parseFloat(product.itemDTOList[0].purchasePrice))">Add to Mall91 Product List</button>
                    </div>
                    
                    <span class="closePopUp" @click="addMarginOnProduct = !addMarginOnProduct">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                        <path
                        fill="#CDCDCD"
                        fill-rule="nonzero"
                        d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                        opacity=".675"
                        />
                    </svg>
                    </span>
                </div>
            </div>
          </div>
        </div>
        <NoDataFound v-if="salesProductStatus && merchandiseId == 0" class="no_record" />
        <infinite-loading
          @infinite="getProductsListing"
          spinner="circles"
          :identifier="resetIdentifier"
          :class="{'errorLog' : isErrorLog}"
        >
          <template slot="no-more" v-if="!salesProductStatus" >{{$t('noMoreRecord')}}</template>
        </infinite-loading>

        <div class="cntntLoad" v-if="loading">
          <img src="../assets/images/loader.gif" alt="loader" />
        </div>
        <div class="loader" v-if="isMarginloading">
          <img src="../assets/images/loader.gif" alt="loader" />
        </div>
      </div>
    </section>
    <div class="cntntLoad" v-if="blankLoad">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <div class="toaster" v-if="isProductAdded">
    <div id="snackbar" :style="{ background: 'green', borderBottomLeftRadius: '10px',borderBottomRightRadius: '10px' }">
      <span class="close_button">
        <i class="material-icons" @click="isProductAdded=false">close</i>
      </span>
      <p class="message">
        <i class="material-icons" :style="{ color: 'green' }">close</i>
        Product Added Successfully <br />
        <span style="    font-size: 0.875em;">To view this product go to your <span @click="$router.push('/manage-shops?shopid=' + $route.query.shopid + '&openTab=myProduct')" style="border-bottom:1px solid #fff">product page</span></span>
      </p>
    </div>
  </div>
  </div>
</template>

<script>
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import CategoryFilter from "../components/ProductListSection/CategoryFilter";
import CategoryFilterOption from "../components/ProductListSection/CategoryFilterOption";
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import CustomToaster from "../components/Common/CustomToaster";
import ListQuantity from "./ListQuantity"
import YoutubeIcon from "@/components/Icons/YoutubeIcon"
import { mapState, mapMutations, mapGetters } from "vuex";
import types from "../store/types";
import CopyIcon from "@/components/Icons/CopyIcon"
export default {
  name: "SupplyProductList",
  watch: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    }
  },
  components: {
    CategoryFilter,
    CategoryFilterOption,
    ImageSpinner,
    NoDataFound,
    CopyIcon,
    YoutubeIcon,
    ListQuantity,
    CustomToaster
  },
  data() {
    return {
        addMarginOnProduct: false,
      appliedFilter: false,
      sortProduct: false,
      merchandiseId: 0,
      pageIndex: 0,
      type: "TRENDING",
      salesProducts: [],
      filterProducts: {
      },
      isDisplay: false,
      choosedCatId: 0,
      selectedcategoryName: "",
      isFilterOption: false,
      loading: false,
      isMarginloading: false,
      noRecord: false,
      salesProductStatus: false,
      orderSourceType: null,
      addTohomeImage: require("../assets/images/mall91_icon.png"),
      dukaanUniqueId: false,
      DukaanbusinessName: "Mall91",
      hideAddtoHomeShowJSbridge: false,
      sortOption: "ASC",
      resetIdentifier: +new Date(),
      orderableQuantity: 1,
      itemId: null,
      toasterData: {},
      isToasterData: false,
      blankLoad: false,
      isErrorLog: false,
      isProductAdded: false,
      updatedSellingPrice: null,
      isTileView: ''
    };
  },
  computed: {
    ...mapState(["savePosition", "saveData"]),
    ...mapGetters(["couponResponse", "cartSize"])
  },
  methods: {
    openCouponChannel(){
      try{
        JSBridgePlugin.genericIntentLaunch("https://www.youtube.com/channel/UCM-3he3y7nnnMT17z-6ZrTQ")
      }catch{
        console.log('not allowed on browser')
      }
    },
    addToShop(index,product, sellingPrice, mrp, mall91price){
            this.isMarginloading = true;
            product.itemDTOList[0].sellerShopId = this.$route.query.shopid;
            product.itemDTOList[0].sellingPrice = sellingPrice;
        ApiCaller(constant.CATALOGUE_URL, "upload-product", "post", product)
        .then((data) => {
            this.isMarginloading = false;
            this.isProductAdded = true;
            let datavalue=Object.assign([],this.salesProducts)
            datavalue[index].isAlreadyExist='yes'
            this.addMarginOnProduct = false;
        })
        .catch((err) => {
          this.isMarginloading = false;
          this.addMarginOnProduct = false;
          product.itemDTOList[0].sellingPrice = mall91price
          this.updatedSellingPrice = null
          if (
            err.response.data.errorCodes[0] == "ITEM_ALREADY_EXISTS_IN_SHOP"
          ) {
            this.toasterData = {
              msg: "Item already exits in shop",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else if (
            err.response.data.errorCodes[0] == "SHOP_NOT_VERIFIED_TO_ADD_EDIT_PRODUCT"
          ) {
            this.toasterData = {
              msg: "Shop not verified to add edit product",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          } else if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else if(err.response.data.message) {
            this.toasterData = {
              msg: err.response.data.message,
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else{
            this.toasterData = {
              msg: "Something went wrong",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }
        });
          this.updatedSellingPrice = null
      },
      addProduct(index,product, sellingPrice, mrp, mall91price){
        if(sellingPrice <= parseFloat(this.updatedSellingPrice) && mrp >= parseFloat(this.updatedSellingPrice)){
            this.isMarginloading = true;
            product.itemDTOList[0].sellerShopId = this.$route.query.shopid;
            product.itemDTOList[0].sellingPrice = this.updatedSellingPrice;
        ApiCaller(constant.CATALOGUE_URL, "upload-product", "post", product)
        .then((data) => {
            this.isMarginloading = false;
            this.isProductAdded = true;
            let datavalue=Object.assign([],this.salesProducts)
            datavalue[index].isAlreadyExist='yes'
            this.addMarginOnProduct = false;
        })
        .catch((err) => {
          this.isMarginloading = false;
          this.addMarginOnProduct = false;
          product.itemDTOList[0].sellingPrice = mall91price
          this.updatedSellingPrice = null
          if (
            err.response.data.errorCodes[0] == "ITEM_ALREADY_EXISTS_IN_SHOP"
          ) {
            this.toasterData = {
              msg: "Item already exits in shop",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else if (
            err.response.data.errorCodes[0] == "SHOP_NOT_VERIFIED_TO_ADD_EDIT_PRODUCT"
          ) {
            this.toasterData = {
              msg: "Shop not verified to add edit product",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          } else if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else if(err.response.data.message) {
            this.toasterData = {
              msg: err.response.data.message,
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }else{
            this.toasterData = {
              msg: "Something went wrong",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
          }
        });
          this.updatedSellingPrice = null
        }else{
            this.isMarginloading = false;
            this.toasterData = {
                msg: `Please enter valid value between ${sellingPrice} and ${mrp}`,
                color: "#E51C24",
                iconName: "close"
            };
            this.isToasterData = true;
        }
      },
      openAddMarginProduct(index){
          this.addMarginOnProduct =index
      },
    getPromoCodeList(){      
      this.blankLoad = true
      ApiCaller(constant.COUPON_API_URL, "get-coupons-for-application/200", "get")
        .then((data) => {
          this.$store.commit(types.COUPON_RESPONSE, data.data.couponDisplayResponseDTOs[0]);       
        }).catch(err =>{
        })
    },
    getUpdatedCartCount(){
      this.$store.commit(types.UPDATE_CART_SIZE, Math.round(parseInt(this.cartSize) + 1));
    },
    ...mapMutations(["setsavePosition"]),
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    JsBridgehideAddtoHome() {
      this.hideAddtoHomeShowJSbridge = false;
    },
    JsBridgeOpenPrompt() {
      window.Cstmbeforeinstallprompt.preventDefault();
      window.Cstmbeforeinstallprompt.prompt();
      let _self = this;
      window.Cstmbeforeinstallprompt.userChoice.then(choice => {
        if (choice.outcome === "accepted") {
          _self.hideAddtoHomeShowJSbridge = false;
        } else if (choice.outcome === "dismissed") {
          _self.hideAddtoHomeShowJSbridge = false;
        }
        window.Cstmbeforeinstallprompt = null;
      });
    },
    viewAllCat() {
      this.isDisplay = true;
    },
    closeAllCat() {
      this.isDisplay = false;
    },
    getProductByCategory(data) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (this.sortOption) {
        data.sortBy = this.sortOption;
      }
      this.loading = true;
      this.salesProductStatus = false;
      this.choosedCatId = parseInt(data.categoryId);
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.salesProducts = [];
      this.resetIdentifier +=1;
    },
    sortByPrice(val) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (this.sortOption == val) {
        this.sortProduct = false;
        return;
      } else {
        this.sortOption = val;
        if (this.filterObject) {
          this.filterObject.sortBy = this.sortOption;
          this.choosedCatId = parseInt(this.filterObject.categoryId);
          this.pageIndex = 0;
          this.$store.commit("saveCategoriesData", {
            categoriesPageIndex: this.pageIndex
          });
          delete this.filterObject.choosedCateName;
          this.salesProducts = [];
          this.resetIdentifier +=1;
        } else {
          const obj = {
            sortBy: val
          };
          this.loading = true;
          this.pageIndex = 0;
          this.filterObject = obj;
          this.salesProducts = [];
          this.resetIdentifier +=1;
        }
      }
    },
    getAppliedFilterList(data) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (this.sortOption) {
        data.sortBy = this.sortOption;
      }
      if (data.categoryId) {
        this.appliedFilter = true;
      }
      this.filterObject = data;
      this.choosedCatId = parseInt(data.categoryId);
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      delete this.filterObject.choosedCateName;
      this.salesProducts = [];
      this.resetIdentifier +=1;
      this.isDisplay = false;
    },
    getClearFilter(data) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (data) {
        this.appliedFilter = true;
      } else {
        this.appliedFilter = false;
      }
    },
    goToProductDetail(productSrId) {
      // localStorage.removeItem('LandOnCategoryListingPage')
       if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)){
         if(this.$route.query.typeOfSource){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.typeOfSource+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier);
         }else if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier);
         }
          
        }else if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier)){
         if(this.$route.query.typeOfSource){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.typeOfSource+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid);
         }else if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid);
         }
          
        } else if(this.$route.query.shopid && this.$route.query.source){
          this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source + '&shopid=' + this.$route.query.shopid);
        }else if(this.$route.query.shopid){
          this.$router.push("/detail/" + productSrId + '?source=LOCAL91_CATEGORY_BROWSING' + '&shopid=' + this.$route.query.shopid);
        }else if(this.$route.query.source){
          this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source);
        }else if(this.$route.query.type === 'MOST_SELLING_PRODUCT'){
          this.$router.push("/detail/" + productSrId + '?source=MOST_SELLING_PRODUCT');
        }else if(this.$route.query.type === 'GMALL_FACTORY_PRODUCTS'){
          this.$router.push("/detail/" + productSrId + '?source=GMALL_FACTORY_PRODUCTS');
        }
        else{
          this.$router.push("/detail/" + productSrId + '?source=LOCAL91_CATEGORY_BROWSING');
        }
    },
    getSubCategory(){
      ApiCaller(constant.LOCAL_SHOP_URL, "get-category-tree/"+ this.$route.query.parentCatId , "get")
              .then(data => {
      if (
        data.data.childCategories
      ) {
        this.filterProducts = data.data.childCategories;
        this.$store.commit("saveCategoryFilterData", {
          catfilterProdList: this.filterProducts
        });
        
      }
      }).catch(err => {
        this.loading = false;
        console.log(err);
      });
    },
    getProductsListing($state) {
      this.loading = true;
      setTimeout(() => {
         if (this.pageIndex != -1) {       
          if (this.$route.query.source) {
            this.orderSourceType = this.$route.query.source;
          } else {
            this.orderSourceType = null;
          }
          let categoryId = 0;
          if (this.type == "NEW_COLLECTION" || this.type == "COLLECTION_FOR_YOU") {
              categoryId = categoryId;
            } else {
              // this.choosedCatId = this.$route.query.categoryid;
            }
            if (this.$store.getters.categoriesPageIndex) {
              this.pageIndex = this.$store.getters.categoriesPageIndex;
            }
            this.$store.commit("saveCatTypeName", {
              catTypeName: this.type
            });    
          if ((this.$route.query.categoryid && this.type != "CLEARANCE_SALE") ||
            this.type == "NEW_COLLECTION" ||
            this.type == "COLLECTION_FOR_YOU"
            ) { 
              if(this.pageIndex > 0){
                localStorage.removeItem('LandOnCategoryListingPage')
              }
              let payloadObject ;
                if(this.$route.query.shopid){
                  payloadObject = this.pageIndex + '?shopid=' + this.$route.query.shopid
                }else{
                  payloadObject = this.pageIndex
                }
                const obj = {
                    pageIndex : this.pageIndex,
                    categoryId : Number(this.choosedCatId),
                    sellerShopId: this.$route.query.shopid
                }
                ApiCaller(constant.CATALOGUE_URL, "get-default-shop-product-to-add",'post',obj)
              .then(data => {                
                this.sortProduct = false;
                if ( data && data.data.productDTOs && data.data.productDTOs.length > 0) { 
                  this.pageIndex = this.pageIndex + 1;
                  this.salesProducts.push(...data.data.productDTOs);
                  this.$store.commit("saveCategoriesData", {
                    categoriesProdList: this.salesProducts,
                    categoriesPageIndex: this.pageIndex
                  });
                  this.loading = false;
                  this.salesProductStatus = false;
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH')
                  }
                  $state && $state.loaded();
                } else {
                  this.pageIndex = -1;
                  this.loading = false;
                  $state && $state.complete();
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH_NO_ITEMS')
                  }
                  if (this.salesProducts.length === 0) {
                    this.salesProductStatus = true;
                  }
                }
              })
              .catch(err => {
                this.loading = false;
                this.isErrorLog = true
                console.log(err);
              });
          }
          if (this.type == "MOST_SELLING_PRODUCT") {
              if (!$state) {
              this.loading = true;
            }
             let payloadObject;
            if(this.$route.query.shopid){
              payloadObject = this.pageIndex + '?shopid=' + this.$route.query.shopid
            }else{
              payloadObject = this.pageIndex
            }
            this.$store
             .dispatch({ type: "getMostsellingProduct", payload: 20, index: payloadObject })
              .then(data => {
                this.loading = false;
                if (data && data.data.filterDataDTO &&
                  this.filterProducts.categoryFilterDTOs == null
                ) {
                  this.filterProducts = data.data.filterDataDTO;
                  this.$store.commit("saveCategoryFilterData", {
                    catfilterProdList: this.filterProducts
                  });
                }else{
                  this.filterProducts = {};
                  this.$store.commit("saveCategoryFilterData", {
                    catfilterProdList: this.filterProducts
                  });
                }
                if (data && data.data.productListingDTOs.length > 0) {
                  this.pageIndex = this.pageIndex + 1;
                  this.salesProducts.push(...data.data.productListingDTOs);
                  this.$store.commit("saveCategoriesData", {
                    categoriesProdList: this.salesProducts,
                    categoriesPageIndex: this.pageIndex
                  });
                  this.loading = false;
                  this.salesProductStatus = false;
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH')
                  }
                  $state && $state.loaded();
                }else {
                  this.pageIndex = -1;
                  this.loading = false;
                  $state && $state.complete();
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH_NO_ITEMS')
                  }
                  if (this.salesProducts.length === 0) {
                    this.salesProductStatus = true;
                  }
                }
              })
              .catch(err => {
                this.loading = false;
                this.isErrorLog = true
                console.log(err);
              });
          }
          if (this.type == "GMALL_FACTORY_PRODUCTS") {
              if (!$state) {
              this.loading = true;
            }
             let payloadObject;
            if(this.$route.query.shopid){
              payloadObject = this.pageIndex + '?shopid=' + this.$route.query.shopid
            }else{
              payloadObject = this.pageIndex
            }
            this.$store
             .dispatch({ type: "getQualityProduct", payload:payloadObject })
              .then(data => {
                this.loading = false;
                if (data && data.data.filterDataDTO &&
                  this.filterProducts.categoryFilterDTOs == null
                ) {
                  this.filterProducts = data.data.filterDataDTO;
                  this.$store.commit("saveCategoryFilterData", {
                    catfilterProdList: this.filterProducts
                  });
                }else{
                  this.filterProducts = {};
                  this.$store.commit("saveCategoryFilterData", {
                    catfilterProdList: this.filterProducts
                  });
                }
                if (data && data.data.productListingDTOs.length > 0) {
                  this.pageIndex = this.pageIndex + 1;
                  this.salesProducts.push(...data.data.productListingDTOs);
                  this.$store.commit("saveCategoriesData", {
                    categoriesProdList: this.salesProducts,
                    categoriesPageIndex: this.pageIndex
                  });
                  this.loading = false;
                  this.salesProductStatus = false;
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH')
                  }
                  $state && $state.loaded();
                }else {
                  this.pageIndex = -1;
                  this.loading = false;
                  $state && $state.complete();
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH_NO_ITEMS')
                  }
                  if (this.salesProducts.length === 0) {
                    this.salesProductStatus = true;
                  }
                }
              })
              .catch(err => {
                this.loading = false;
                this.isErrorLog = true
                console.log(err);
              });
          }
        }
        
        });
        
     
      
    },
    getCategoryTracking(sourceValue){
      ApiCaller(
          constant.LOCAL_SHOP_URL,
          'add-user-traking/?orderSourceType=' + sourceValue,
          'post'
        )
        .then((data) => {

        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    if(this.$store.state.isViewType){
      this.isTileView = this.$store.state.isViewType
    }
    if(this.couponResponse && !this.couponResponse.discountedAmount){
      // this.getPromoCodeList()
    }
    localStorage.setItem('LandOnCategoryListingPage', true)
    if(this.$route.query.parentCatId)
    this.getSubCategory()
    this.choosedCatId = Number(this.$route.query.categoryid)
    if (this.$store.getters.catTypeName === this.$route.query.type) {
      
      if (this.$store.getters.catfilterProdList) {
        this.filterProducts = this.$store.getters.catfilterProdList;
      }
      if (
        this.$store.getters.categoriesProdList &&
        this.$store.getters.categoriesProdList.length > 0 &&
        this.$store.getters.categoriesPageIndex
      ) {
        this.salesProducts = this.$store.getters.categoriesProdList;
        this.pageIndex = this.$store.getters.categoriesPageIndex;
      }
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
    }
    if (this.salesProducts.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
    this.pageIndex = 0;
    if (this.$route.query.type && this.$route.query.type != null) {
      this.type = this.$route.query.type;
    } else {
      this.type = "NORMAL";
    }
    
  },

};
</script>
<style lang="scss" scoped>
#snackbar {
  width: 100%;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 14px;
  position: fixed;
  z-index: 99;
  padding-right: 30px;
  top: 0;
  left: 0;
  animation: ak 0.2s 1;
  box-shadow: rgba(0, 0, 0, 0.22) 0px 2px 10px 0px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
#snackbar .close_button {
  top: 12px;
  right: 5px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 9;
}
#snackbar .close_button i {
  color: #ccc;
  font-size: 1.25em;
  font-weight: 600;
}
#snackbar .message {
  font-size: 0.938em;
  position: relative;
  padding-left: 29px;
  text-align: left;
}
#snackbar .message i {
  background: #fff;
  border-radius: 50%;
  font-size: 1em;
  padding: 2px 1px 1px;
  margin-right: 5px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.option_selection{
    .add-option{
        color: #0091FF;
    background: #fff;
    border: 1px solid #0091FF;
    &.added{
      background: #727272;
      border: 1px solid #727272;
      color: #fff
    }
    }
}
.my_price_section{
    span{
        
        &.my_price,&.selling_price{
            padding: 0;
            display: block;
            // text-decoration: none;
            margin-bottom: 4px;
        }
        &.my_price{
              font-size: 0.938em;
        }
        &.selling_price{
          .rupee-font{
            text-decoration: line-through;
          }
        }
        
    }
}
.detail_content{
  padding: 66px 0 20px;
}
.productListing .detail_content .main_customHeading.topZero{
  top: 0
}
.productListing .detail_content .main_customHeading.topHeight{
  top: 44px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
p.product-name {
  font-size: 0.87em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  white-space: nowrap;
//   margin-bottom: 5px;
}
.sortOption {
  color: #0091ff;
}
.infinite-status-prompt{
  color: #fff !important;
}
.productListing .detail_content.paddingMore{
  padding-top: 85px;
}
</style>